import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Checkbox } from 'semantic-ui-react'
import StockExChangeService from '~/api/services/stockExchange'
import Dialog from '~/components/Dialog'
import notify from '~/components/Notify'
import { handleErrors } from '~/utils/helpers'

interface NotifyModalProps {
  openModal: boolean
  handleClose: () => void
  showData: any
}

const NotifyModal: React.FC<NotifyModalProps> = (props) => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { openModal, handleClose, showData } = props

  const [confirmedRecipientsIds, setConfirmedRecipientsIds] = useState([])
  const [numberOfRecipients, setNumberOfRecipients] = useState(0)
  const [loadingRecipients, setLoadingRecipients] = useState(false)
  const [isBusy, setIsBusy] = useState(false)

  useEffect(() => {
    if (confirmedRecipientsIds.length > 0) {
      handleLoadNumberOfRecipients()
    }
  }, [confirmedRecipientsIds])

  async function handleLoadNumberOfRecipients() {
    setLoadingRecipients(true)
    try {
      const response = await StockExChangeService.notifyFarmersTradingSlot(id, { farmerGroups: confirmedRecipientsIds })
      setNumberOfRecipients(response.data)
    } catch (error) {
      handleErrors(error)
    }
    setLoadingRecipients(false)
  }

  function handleCheckedFarmers(checked, id) {
    if (checked) {
      setConfirmedRecipientsIds([...confirmedRecipientsIds, id])
    } else {
      setConfirmedRecipientsIds(confirmedRecipientsIds.filter(confirmedRecipientsId => confirmedRecipientsId !== id))
    }
  }

  async function handleNotify() {
    setIsBusy(true)
    try {
      await StockExChangeService.notifyFarmers(id, { farmerGroups: confirmedRecipientsIds })
      setConfirmedRecipientsIds([])
      setNumberOfRecipients(0)
      notify(t('Farmers notified'), 'success')
      handleClose()
    } catch (error) {
      handleErrors(error)
    }
    setIsBusy(false)
  }

  const uniqId = showData?.uniqueId

  return <Dialog
    isDialogOpen={openModal}
    textClose={t('Close')}
    isLoading={loadingRecipients || isBusy}
    handleClose={() => {
      setNumberOfRecipients(0)
      setConfirmedRecipientsIds([])
      handleClose()
    }}
    textSubmit={t('Send')}
    handleSubmit={() => handleNotify()}
    disableSubmit={numberOfRecipients === 0}
    textContent={<>
      <div style={{ margin: '20px 0px', fontWeight: 'bold', textAlign: 'center' }}>
        {t('Please note that every farmer who belongs to one of the selected farmer group(s) will receive an email with the information of the trading slot {{uniqId}}. \n\
      Would you like to send the email to all affected farmers?', { uniqId })}</div>
      <div style={{ margin: '20px 0px', textAlign: 'center' }}>
        {showData?.farmerGroups.map(farmerRecipient => {
          return <Checkbox
            style={{ margin: '0px 10px' }}
            label={farmerRecipient.name}
            key={farmerRecipient.id}
            checked={confirmedRecipientsIds.find(confirmedRecipient => confirmedRecipient === farmerRecipient.id)}
            onChange={(e, data) => handleCheckedFarmers(data.checked, farmerRecipient.id)}
          />
        })}
      </div>
      <div style={{ margin: '20px 0px', textAlign: 'center' }}>{t('Number of email recipients: {{numberOfRecipients}}', { numberOfRecipients })}</div>
    </>}
    textHeader={t('Notify farmers')}
    type={'dialog'}
  />
}
export default NotifyModal